// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__4mv0K","footer":"ModalUpdate_footer__ZvKrn"};